import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { IcoAppclip16 } from '@onefootprint/icons';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { DeviceInsightEvent } from '@/components/entities/components/details/hooks/use-entity-device-insights';
import { useEntityContext } from '@/entity/hooks/use-entity-context';
import { displayForUserAgent, icoForUserAgent, isAppClip } from '@/utils/user-agent';
import CardBase from '../card-base';
import CardRow from '../card-row';
import AboutAppClipAndInstantApp from './components/about-app-clip-and-instant-app';
import getRegion from './utils/get-region';
type InsightEventCardProps = {
  id: string;
  isSelected?: boolean;
  onSelect?: (id: string) => void;
  data: DeviceInsightEvent;
};
const InsightEventCard = t0 => {
  const $ = _c(86);
  const {
    id,
    data,
    isSelected,
    onSelect
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "deviceInsights"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const context = useEntityContext();
  const {
    formatDateWithTime
  } = useIntl();
  const {
    data: t2
  } = data.event;
  const {
    insight,
    kind,
    authEventKind
  } = t2;
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp2);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp3);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5) {
    t6 = {
      email: t3,
      passkey: t4,
      sms: t5
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const AuthEventKindToText = t6;
  const t7 = insight?.city;
  const t8 = insight?.region;
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = getRegion(t7, t8);
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const fullRegion = t9;
  const t10 = insight?.userAgent ?? "";
  let t11;
  if ($[14] !== t10) {
    t11 = displayForUserAgent(t10);
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const headerText = t11;
  let t12;
  if ($[16] !== t) {
    t12 = t(_temp4);
    $[16] = t;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== formatDateWithTime || $[19] !== insight?.timestamp) {
    t13 = formatDateWithTime(new Date(insight?.timestamp ?? 0));
    $[18] = formatDateWithTime;
    $[19] = insight?.timestamp;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12 || $[22] !== t13) {
    t14 = <CardRow key="date-time" label={t12} value={t13} />;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let rows;
  if ($[24] !== AuthEventKindToText || $[25] !== authEventKind || $[26] !== context.kind || $[27] !== fullRegion || $[28] !== insight || $[29] !== t || $[30] !== t14) {
    rows = [t14];
    if (insight?.ipAddress) {
      let t15;
      if ($[32] !== t) {
        t15 = t(_temp5);
        $[32] = t;
        $[33] = t15;
      } else {
        t15 = $[33];
      }
      let t16;
      if ($[34] !== insight.ipAddress || $[35] !== t15) {
        t16 = <CardRow key="ip-address" label={t15} value={insight.ipAddress} />;
        $[34] = insight.ipAddress;
        $[35] = t15;
        $[36] = t16;
      } else {
        t16 = $[36];
      }
      rows.push(t16);
    }
    if (isAppClip(insight?.userAgent)) {
      let t15;
      if ($[37] !== t) {
        t15 = t(_temp6);
        $[37] = t;
        $[38] = t15;
      } else {
        t15 = $[38];
      }
      let t16;
      if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = <AboutAppClipAndInstantApp kind="appClip" />;
        $[39] = t16;
      } else {
        t16 = $[39];
      }
      let t17;
      if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = <IcoAppclip16 />;
        $[40] = t17;
      } else {
        t17 = $[40];
      }
      let t18;
      if ($[41] !== t) {
        t18 = t(_temp7);
        $[41] = t;
        $[42] = t18;
      } else {
        t18 = $[42];
      }
      let t19;
      if ($[43] !== t18) {
        t19 = <div className="flex items-center gap-1 justify-end">{t17}<span className="text-body-2 text-primary" data-dd-privacy="mask">{t18}</span></div>;
        $[43] = t18;
        $[44] = t19;
      } else {
        t19 = $[44];
      }
      let t20;
      if ($[45] !== t15 || $[46] !== t19) {
        t20 = <CardRow key="app-clip" label={t15} labelSuffix={t16} value={t19} />;
        $[45] = t15;
        $[46] = t19;
        $[47] = t20;
      } else {
        t20 = $[47];
      }
      rows.push(t20);
    }
    if (context.kind === "person") {
      if (authEventKind) {
        let t15;
        if ($[48] !== t) {
          t15 = t(_temp8);
          $[48] = t;
          $[49] = t15;
        } else {
          t15 = $[49];
        }
        const t16 = AuthEventKindToText[authEventKind];
        let t17;
        if ($[50] !== t15 || $[51] !== t16) {
          t17 = <CardRow key="auth-method" label={t15} value={t16} />;
          $[50] = t15;
          $[51] = t16;
          $[52] = t17;
        } else {
          t17 = $[52];
        }
        rows.push(t17);
      }
      if (fullRegion) {
        let t15;
        if ($[53] !== t) {
          t15 = t(_temp9);
          $[53] = t;
          $[54] = t15;
        } else {
          t15 = $[54];
        }
        let t16;
        if ($[55] !== fullRegion || $[56] !== t15) {
          t16 = <CardRow key="region" label={t15} value={fullRegion} />;
          $[55] = fullRegion;
          $[56] = t15;
          $[57] = t16;
        } else {
          t16 = $[57];
        }
        rows.push(t16);
      }
      if (insight?.country) {
        let t15;
        if ($[58] !== t) {
          t15 = t(_temp10);
          $[58] = t;
          $[59] = t15;
        } else {
          t15 = $[59];
        }
        let t16;
        if ($[60] !== insight.country || $[61] !== t15) {
          t16 = <CardRow key="country" label={t15} value={insight.country} />;
          $[60] = insight.country;
          $[61] = t15;
          $[62] = t16;
        } else {
          t16 = $[62];
        }
        rows.push(t16);
      }
    }
    $[24] = AuthEventKindToText;
    $[25] = authEventKind;
    $[26] = context.kind;
    $[27] = fullRegion;
    $[28] = insight;
    $[29] = t;
    $[30] = t14;
    $[31] = rows;
  } else {
    rows = $[31];
  }
  let t15;
  if ($[63] !== t) {
    t15 = t(_temp11);
    $[63] = t;
    $[64] = t15;
  } else {
    t15 = $[64];
  }
  let t16;
  if ($[65] !== t) {
    t16 = t(_temp12);
    $[65] = t;
    $[66] = t16;
  } else {
    t16 = $[66];
  }
  let t17;
  if ($[67] !== t) {
    t17 = t(_temp13);
    $[67] = t;
    $[68] = t17;
  } else {
    t17 = $[68];
  }
  let t18;
  if ($[69] !== t15 || $[70] !== t16 || $[71] !== t17) {
    t18 = {
      identify: t15,
      handoff: t16,
      auth_event: t17
    };
    $[69] = t15;
    $[70] = t16;
    $[71] = t17;
    $[72] = t18;
  } else {
    t18 = $[72];
  }
  const kindToText = t18;
  const title = kindToText[kind];
  let t19;
  if ($[73] !== id || $[74] !== onSelect) {
    t19 = () => onSelect?.(id);
    $[73] = id;
    $[74] = onSelect;
    $[75] = t19;
  } else {
    t19 = $[75];
  }
  const t20 = insight?.userAgent ?? "";
  let t21;
  if ($[76] !== t20) {
    t21 = icoForUserAgent(t20, "quinary");
    $[76] = t20;
    $[77] = t21;
  } else {
    t21 = $[77];
  }
  let t22;
  if ($[78] !== headerText || $[79] !== id || $[80] !== isSelected || $[81] !== rows || $[82] !== t19 || $[83] !== t21 || $[84] !== title) {
    t22 = <CardBase id={id} isSelected={isSelected} onSelect={t19} title={title} headerIcon={t21} headerText={headerText} rows={rows} />;
    $[78] = headerText;
    $[79] = id;
    $[80] = isSelected;
    $[81] = rows;
    $[82] = t19;
    $[83] = t21;
    $[84] = title;
    $[85] = t22;
  } else {
    t22 = $[85];
  }
  return t22;
};
export default InsightEventCard;
function _temp($) {
  return $.authEventKind.email;
}
function _temp2($_0) {
  return $_0.authEventKind.passkey;
}
function _temp3($_1) {
  return $_1.authEventKind.sms;
}
function _temp4($_2) {
  return $_2.dateAndTime;
}
function _temp5($_3) {
  return $_3.ipAddress;
}
function _temp6($_4) {
  return $_4.appClip.label;
}
function _temp7($_5) {
  return $_5.appClip.yes;
}
function _temp8($_6) {
  return $_6.authMethod;
}
function _temp9($_7) {
  return $_7.region;
}
function _temp10($_8) {
  return $_8.country;
}
function _temp11($_9) {
  return $_9.insightKind.identify;
}
function _temp12($_10) {
  return $_10.insightKind.handoff;
}
function _temp13($_11) {
  return $_11.insightKind.auth_event;
}